/* =========================================================================
   HOLY FOREST — RECHENZEILE IM KAUFBEREICH

   Rechnet mit, was die Menge kostet: Mengenrabatt und Versandgrenze stehen
   sonst erst im Warenkorb — also nach der Entscheidung. Am 26.08.2026 an der
   Shopify-API geprueft: "2 Flaschen − 15 %" ist aktiv und ohne Enddatum,
   versandfrei ab 100 € (AT/DE).

   ALLES DELEGIERT, nichts fest gebunden. Taste tauscht bei Variantenwechsel
   den halben Kaufbereich gegen frisch gerendertes HTML aus — fest gebundene
   Listener waeren danach tot. Deshalb haengen die Listener an document und
   jede Rechnung sucht ihre Elemente neu.

   Zahlen kommen aus dem Markup (snippets/hf-rechner.liquid), nicht von hier.
   Geldformat: window.hfGeld aus holyforest-geld.js.
   ========================================================================= */

(function () {
  var zahl = function (el, name, ersatz) {
    var v = parseFloat(el.getAttribute(name));
    return isNaN(v) ? ersatz : v;
  };

  var rechnen = function () {
    var w = document.querySelector('.hf-rech');
    if (!w || typeof window.hfGeld !== 'function') return;

    var zeile = w.querySelector('.hf-rech__zeile');
    var tipp = w.querySelector('.hf-rech__tipp');
    var bereich = w.closest('product-info') || w.closest('.shopify-section') || document;

    var mengeFeld = bereich.querySelector('input[name="quantity"]');
    var idFeld = bereich.querySelector('form[action*="/cart/add"] [name="id"]');

    var preise = {};
    try { preise = JSON.parse(w.getAttribute('data-preise') || '{}'); } catch (e) {}

    var preis = zahl(w, 'data-preis', 0);
    if (idFeld && preise[idFeld.value] != null) preis = preise[idFeld.value];
    if (!preis) return;

    var stk = Math.max(1, parseInt(mengeFeld && mengeFeld.value, 10) || 1);
    var dosen = zahl(w, 'data-dosen', 20);
    var rabatt = zahl(w, 'data-rabatt', 0);
    var abMenge = zahl(w, 'data-ab', 2);
    var freiAb = zahl(w, 'data-frei', 0) * 100;

    var voll = preis * stk;
    var greift = stk >= abMenge;
    var end = greift ? Math.round(voll * (100 - rabatt) / 100) : voll;

    var text = '<b>' + window.hfGeld(end) + '</b>';
    if (greift) {
      text += ' <s>' + window.hfGeld(voll) + '</s> · <em>−' + rabatt + ' %</em>'
            + ' · ' + window.hfGeld(Math.round(end / (dosen * stk))) + ' je Tagesdosis';
    }
    if (freiAb > 0) {
      text += end >= freiAb ? ' · versandfrei' : ' · noch ' + window.hfGeld(freiAb - end) + ' bis versandfrei';
    }
    zeile.innerHTML = text;

    if (tipp) {
      var zeigen = rabatt > 0 && stk < abMenge;
      tipp.hidden = !zeigen;
      if (zeigen) {
        tipp.textContent = abMenge + ' nehmen — ' + rabatt + ' % sparen';
        tipp.setAttribute('data-menge', abMenge);
      }
    }
  };

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('input[name="quantity"]')) rechnen();
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[name="quantity"], [name="id"]')) rechnen();
  });

  /* Der Knopf setzt die Menge und loest dasselbe change-Ereignis aus, das
     auch Tastes Plusknopf ausloest — sonst bekaeme der Warenkorb die neue
     Menge nicht mit. */
  document.addEventListener('click', function (e) {
    var tipp = e.target.closest && e.target.closest('.hf-rech__tipp');
    if (!tipp) return;
    var w = tipp.closest('.hf-rech');
    var bereich = w.closest('product-info') || w.closest('.shopify-section') || document;
    var feld = bereich.querySelector('input[name="quantity"]');
    if (!feld) return;
    feld.value = tipp.getAttribute('data-menge') || 2;
    feld.dispatchEvent(new Event('change', { bubbles: true }));
    rechnen();
  });

  /* Taste rendert den Kaufbereich bei Variantenwechsel neu. */
  document.addEventListener('variant:change', function () { window.setTimeout(rechnen, 60); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rechnen);
  else rechnen();
})();
